import React from 'react';
import IcrPreview from '../components/IcrPreview';
import LoginButton from '../LoginButton';
import Home from '../pages/home';
import Dashboard from '../Dashboard';
import AuthSuccess from '../AuthSuccess'
import AuthError from '../AuthError';
import AccessDeniedPage from '../AccessDeniedPage';


export const RoutePaths = [
    {
        path: '/',
        element: <LoginButton />
    },{

        path: '/login',
        element: <LoginButton />
    },
    {
        path: '/dashboard',
        element: <Dashboard/>
    },
    {
        path: '/preview/:id',
        element: <IcrPreview />
    },
    {
        path: '/home',
        element: <Home/>
    },
    {
        path: '/auth/success',
        element: <AuthSuccess/>
    },
    {
        path: '/auth/error',
        element: <AuthError/>
    },
    {
        path: '/access/denied',
        element: <AccessDeniedPage/>
    }
];
